module.exports = __webpack_public_path__ + "static/media/exclusive-demand.b04ba117.jpeg";